import { Component } from '@angular/core';
import { BaseInjectorService } from 'src/app/base/base-service.injecter';

@Component({
    selector: 'lh-popover-help',
    templateUrl: './popover-help.component.html',
    styleUrls: ['./popover-help.component.scss'],
    standalone: false
})
export class PopoverHelpComponent extends BaseInjectorService {
  constructor() {
    super();
  }

  closePopover(action) {
    this.dismissPopOver(action);
  }
}
